export default {"src":"/_next/static/media/first_dev_login.1043f6e3.svg","height":781,"width":1220,"blurWidth":0,"blurHeight":0};